import { AuthSession } from '../types/api';

const STORAGE_KEY = 'inventory-erp.auth';

const canUseStorage = (): boolean =>
  typeof window !== 'undefined' && Boolean(window.localStorage);

export const authStorage = {
  get(): AuthSession | null {
    if (!canUseStorage()) return null;
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AuthSession;
    } catch {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  },

  save(session: AuthSession): void {
    if (canUseStorage()) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    }
  },

  clear(): void {
    if (canUseStorage()) window.localStorage.removeItem(STORAGE_KEY);
  },

  getAccessToken(): string | null {
    return this.get()?.accessToken ?? null;
  },

  getRefreshToken(): string | null {
    return this.get()?.refreshToken ?? null;
  },
};
